import Image from 'next/image';
import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, FreeMode, Mousewheel, Navigation, Pagination } from 'swiper';
import styles from '../../../styles/HomeLanding/IndiaLandingPage.module.css'
import customStyles from '../../../styles/HomeLanding/AllInOneIndia.module.css'
import dynamic from 'next/dynamic';
import { allInOnePOSData } from '@/constants/common';
const gsap = dynamic(() => import('gsap'), { ssr: false });
const ScrollTrigger = dynamic(() => import('gsap/dist/ScrollTrigger'), { ssr: false });


const AllInOnePOSIndia = () => {
  const [selectedCategory, setSelectedCategory] = useState('Retail');

  useEffect(() => {
    let gsapInstance;
    let ScrollTriggerInstance;
    const triggers = [];
    // Track which images have already been animated to prevent reversing
    const animatedImages = new Set();
  
    const initializeGSAP = async () => {
      if (typeof window !== 'undefined') {
        const gsapModuleLoaded = await import('gsap');
        const ScrollTriggerModuleLoaded = await import('gsap/dist/ScrollTrigger');
  
        gsapInstance = gsapModuleLoaded.default;
        ScrollTriggerInstance = ScrollTriggerModuleLoaded.ScrollTrigger ?? ScrollTriggerModuleLoaded.default?.ScrollTrigger ?? ScrollTriggerModuleLoaded.default;
  
        gsapInstance.registerPlugin(ScrollTriggerInstance);
  
        allInOnePOSData[selectedCategory]?.forEach((item, index) => {
          ['img1', 'img2', 'img3', 'img4']?.forEach((imgKey) => {
            const img = item[imgKey];
            if (img?.style) {
              const id = `.animated-img[data-id="${imgKey}-${index}"]`;
              const imageKey = `${imgKey}-${index}`;
              
              const targetWidth = img.style.enterWidth;
              const targetHeight = img.style.enterHeight;
  
              const trigger = ScrollTriggerInstance.create({
                trigger: id,
                start: "50% bottom",
                end: "top top",
                onEnter: () => {
                  animatedImages.add(imageKey);
                  gsapInstance.to(id, {
                    width: targetWidth,
                    height: targetHeight,
                    duration: 0.5,
                    ease: "power2.out"
                  });
                },
                onLeave: () => {
                  if (!animatedImages.has(imageKey)) {
                    gsapInstance.to(id, {
                      width: img.style.initialWidth,
                      height: img.style.initialHeight,
                      duration: 0.5,
                      ease: "power2.out"
                    });
                  }
                },
                onEnterBack: () => {
                  animatedImages.add(imageKey);
                  gsapInstance.to(id, {
                    width: targetWidth,
                    height: targetHeight,
                    duration: 0.5,
                    ease: "power2.out"
                  });
                },
                onLeaveBack: () => {
                  if (!animatedImages.has(imageKey)) {
                    gsapInstance.to(id, {
                      width: img.style.initialWidth,
                      height: img.style.initialHeight,
                      duration: 0.5,
                      ease: "power2.out"
                    });
                  }
                },
              });
  
              triggers.push(trigger);
            }
          });
        });
      }
    };
  
    initializeGSAP();
  
    return () => {
      triggers.forEach(trigger => trigger.kill());
    };
  }, [selectedCategory]);
  const customSwiperStyle = {
    '.swiper-pagination': {
      marginTop: '-12px'
    }
  };


   
  const categoryRoutes = {
    Retail: '/Industries/retail-pos-billing-software',
    Restaurants: '/Industries/restaurant-pos-billing-software',
    Grocery: '/Industries/grocery-pos-billing-software',
    Electronics: '/Industries/electronic-pos-billing-software',
    Services: '/Industries/spa-and-salon-pos-billing-software',
  };

  const router = require('next/router').useRouter ? require('next/router').useRouter() : null;

  const handleVectorClick = () => {
    const route = categoryRoutes[selectedCategory];
    if (router && route) {
      router.push(route);
    }
  };

  const [knowMoreHover, setKnowMoreHover] = useState(false);
  return (
    <div className={customStyles.allinoneIndiaContainer} style={{ backgroundColor: "#F2FAFF", padding: "2rem 5rem", borderRadius: "5rem" }}>
      <div style={{ display: 'flex', justifyContent: "space-between", margin: "3rem 1rem" }}>
        <div style={{ display: 'flex', }}>
          <h2 style={{ fontSize: "2.8rem", fontFamily: "GilroyBold", lineHeight:"120%" }}>
            All-In-One <br />
            <span style={{ color: '#2A6AB4' }}>POS Solution</span>
          </h2>
          <div className={styles.vector} onClick={handleVectorClick} style={{ cursor: 'pointer' }}>
            <div className={styles.vectorImg} >
              <Image src="/assets/HomeLanding/Vector.svg" alt="POS Solution" fill />
            </div>
          </div>
        </div>

        <div style={{ backgroundColor: "white", borderRadius: "4rem", display: "flex", alignItems: "center", padding: '1rem', height: "6.5rem" }}>
          {Object.keys(allInOnePOSData).map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              style={{
                fontSize:"1.4rem",
                margin: '0.3rem',
                padding: "1rem 2.1rem",
                borderRadius: "2.5rem",
                border: "none",
                outline: "none",
                color: selectedCategory === category ? "white" : "black",
                backgroundColor: selectedCategory === category ? "#2A6AB4" : "white",
                cursor: "pointer",
                fontFamily: "GilroyMedium"
              }}
            >
              {category}
            </button>
          ))}
        </div>
      </div>



      <Swiper
        spaceBetween={30}
        slidesPerView={'auto'}
        autoplay={{
          delay: 10000,
          disableOnInteraction: false,
        }}
        speed={1000}
        pagination={{ clickable: true }}
        modules={[Autoplay, Pagination, Mousewheel, FreeMode]}
        className="custom-features-swiper allinone-india-swiper"
        freeMode={true}
        mousewheel={{
          forceToAxis: true,
          invert: false,
          sensitivity: 1,
        }}
        grabCursor={true}
      >
        {allInOnePOSData[selectedCategory]?.map((item, index) => (
          <SwiperSlide key={index} style={{ width: "43rem",}}>
            <div
              style={{
                flex: "0 0 auto",
                marginBottom: "20px",
                alignItems: "center",
                backgroundColor: "#ffff",
                borderRadius: "2rem",
                padding: "3rem",
                width:"100%"
                
              }}
            >
              <div style={{ display: "flex", gap: "1.2rem", alignItems: "center" }}>
                {/* icon */}
                <div style={{ position: 'relative', width: '3.5rem', height: '3.5rem', marginBottom: "1rem" }}>
                  <Image
                    src={item.icon}
                    alt={item.title}
                    fill
                  />
                </div>
                <h3 style={{ fontSize: "2rem", marginBottom: "1rem", fontFamily: "GilroySemiBold" }}>{item.title}</h3>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "31rem",
                  width: "100%",
                }}
              >
                <div>
                  <p style={{ fontSize: "1.4rem", color: "#555", fontFamily: "GilroyMedium" }}>{item.text}</p>
                </div>

                {/* image  */}
                <div style={{ position: "relative", width: item.width, aspectRatio: "944 / 528", borderRadius: "2rem", overflow: "hidden" }}
                  // className={styles.images}
                  >
                  <Image src={item.image} alt={item.altText} fill sizes="37rem" style={{ objectFit: "contain" }} />

                  {['img1', 'img2', 'img3', 'img4'].map((imgKey, imgIndex) => {
                    const img = item[imgKey];
                    return img ? (
                      <div
                        key={imgIndex}
                        className={`animated-img ${styles[`small_Images${imgIndex + 1}`]}`}
                        data-id={`${imgKey}-${index}`}
                        style={{
                          position: 'absolute',
                          ...img.style,
                        }}
                      >
                        <Image src={img.src} alt={`${item.title} ${imgIndex + 1}`} fill />
                      </div>
                    ) : null;
                  })}
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div style={{ textAlign: 'right' }}>
        <span
          className={customStyles.knowMoreLink}
          onClick={handleVectorClick}
        >
          Know more
        </span>
      </div>
    </div>
  );
};


export default AllInOnePOSIndia
